/* DAILE v2 (dv) — catalog v2 «Salon», round 5: the view switcher of a
 * collection page (sections/dv-catalog-main, snippets/dv-catalog-view-switch).
 *
 * Gallery (the hangs, default) / Grid / List. All three are in the page
 * already: the grid and the list share one plain markup (.dv-cv) that CSS
 * shows for data-dv-view="grid|list" on the section, hiding the gallery after
 * it (assets/dv-catalog-views.css). No reload, so pagination (?page=) and the
 * #artworks anchor keep working in every view.
 *
 * The choice is remembered per viewer in localStorage ("dv-catalog-view", the
 * same for every collection); an inline script at the top of the section
 * applies it before the works are parsed, this file keeps aria-pressed in step
 * and keeps the switcher where it was on screen when the view changes.
 */
(() => {
  'use strict';

  const KEY = 'dv-catalog-view';
  const VIEWS = ['gallery', 'grid', 'list'];

  const read = () => {
    try {
      const value = localStorage.getItem(KEY);
      return VIEWS.includes(value) ? value : 'gallery';
    } catch (error) {
      return 'gallery';
    }
  };

  const write = (value) => {
    try {
      if (value === 'gallery') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, value);
    } catch (error) {
      /* private mode: the view simply is not remembered */
    }
  };

  const apply = (root, view) => {
    if (view === 'gallery') root.removeAttribute('data-dv-view');
    else root.setAttribute('data-dv-view', view);
    root.querySelectorAll('[data-dv-view-set]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.dvViewSet === view));
    });
  };

  const init = (root) => {
    if (root.dataset.dvViewsReady) return;
    root.dataset.dvViewsReady = '1';
    root.setAttribute('data-dv-views-on', '');
    apply(root, read());

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-dv-view-set]');
      if (!button || !root.contains(button)) return;
      const view = button.dataset.dvViewSet;
      if (!VIEWS.includes(view)) return;
      const bar = button.closest('.dv-cv-bar') || button;
      const before = bar.getBoundingClientRect().top;
      apply(root, view);
      write(view);
      // The switcher stays where the finger or pointer left it.
      const shift = bar.getBoundingClientRect().top - before;
      if (Math.abs(shift) > 1) window.scrollBy({ top: shift, behavior: 'instant' });
      // Other sections showing a view switcher follow the same choice.
      document.querySelectorAll('[data-dv-views]').forEach((other) => {
        if (other !== root) apply(other, view);
      });
    });
  };

  const run = () => document.querySelectorAll('[data-dv-views]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
